<template>
    <div class="container -mt-20p">
        <div class="row">
            <div class="col d-flex mt-4 pt-5 flex-column">
                <div class="instructions-headings activation-ended mx-auto">
                    <h1 class="text-center">
                        Te informăm că această activare<br>s-a încheiat.
                    </h1>

                    <h3 class="mt-4 text-center">Mulțumim întregii echipe pentru contribuția de până acum!</h3>
                </div>
            </div>
            
        </div>
        <div class="row">
            <div class="col mx-auto pt-4 pb-3 d-flex justify-content-center">
                <div class="start-quiz-box activation-ended-box">
                    <a @click.prevent="resetPromiseAction()" class="button button--dark mx-auto">Deconectare</a>
                </div>
            </div>
        </div>
        <Slide right :closeOnNavigation="true" noOverlay width="260">
                <a @click.prevent="resetPromiseAction()">Deconectare</a>
        </Slide>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Slide } from 'vue-burger-menu';

export default {
    name: 'ActivationEnded',
    components: {
        Slide
    },
    methods: {
        ...mapActions({
            resetPromiseAction: 'resetPromiseAction'
        })
    }
}
</script>

<style>

</style>